import Vue from 'vue'
import Vuex from 'vuex'
import workout from './workout.js'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        workout
    }
});